import React, { useState } from 'react';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa'; // Import carets for the dropdown
import { FaDollarSign } from "react-icons/fa";
import './DropdownHeader.scss';

function DropdownHeader() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = (e) => {
    // Prevent the dropdown from toggling when clicking on the content itself
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className="dropdown-header">
      <div className="header-content" onClick={toggleDropdown}>
      <FaDollarSign className="icon" /> {/* Replace with your icon path */}
        <span className="header-text">USDT exchange DDB</span>
      </div>
      <div className="rate-toggle" onClick={toggleDropdown}>
        <span className="conversion-rate">1 USDT = 7.5 DDB</span>
        {isDropdownOpen ? <FaCaretUp className="caret" /> : <FaCaretDown className="caret" />}
      </div>
      {isDropdownOpen && (
        <div className="dropdown-content">
          {/* Dropdown content here */}
          Additional information...
        </div>
      )}
    </div>
  );
}

export default DropdownHeader;
